import { SET_ART_WALL_CANVAS_REF } from './../const';

export default (artWallCanvasRef) => {
  return {
    type: SET_ART_WALL_CANVAS_REF,
    artWallCanvasRef: artWallCanvasRef
  }
};
